import { gsap } from 'gsap'

export default () => ({
	theme: 'light',
	isScrolled: false,

	init() {
		this.onRouteChange()

		this.onRouteChange = this.onRouteChange.bind(this)
		this.handleScroll = this.handleScroll.bind(this)

		this.setupScrollListener()
		this.setupRouteListener()
	},

	onRouteChange() {
		const path = window.location.pathname

		if (path.includes('collection') || path.includes('product')) {
			this.theme = 'dark'
		} else {
			this.theme = 'light'
		}
	},

	setupRouteListener() {
		if (typeof window === 'undefined') return

		window.app?.swup?.hooks.on('content:replace', this.onRouteChange)
	},

	setupScrollListener() {
		if (typeof window === 'undefined') return

		window.addEventListener('scroll', this.handleScroll)
	},

	handleScroll() {
		const scroll = window.scrollY

		if (scroll > window.innerHeight) {
			this.isScrolled = true
		} else {
			this.isScrolled = false
		}
	},

	destroy() {
		if (typeof window === 'undefined') return

		window.removeEventListener('scroll', this.handleScroll)
		// window.app?.swup?.hooks.off('content:replace', this.onRouteChange)
	},
})
